import React from 'react'

export const Blog = () => {
  return (
    //  <div className="container py-5">

  <div className="page_content_wrap  bgcolor_servicetop">
  <div className="content_wrap">
    <div className="content">
      <a
        id="content_skip_link_anchor"
        className="agricola_skip_link_anchor"
        href="#"
      />


<section className='container-paddingtop'></section>
      {/* <div className='bgcolor_servicetop'> */}


{/* Blog Header */}
<div className="min-h-screen bg-background">
      <section className="container mx-auto px-4 py-16 md:py-24 lg:py-32">
        <div className="flex flex-col items-center justify-center text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground mb-6 md:mb-8">
            Blog
          </h1>
          <i className="fa-solid fa-chevron-down"></i>
       
        </div>
      </section>
    </div>
</div>




      <article
        id="post-17910"
        className="post_item_single post_type_page post-17910 page type-page status-publish hentry"
      >
        <div className="post_content entry-content">
          <div
            data-elementor-type="wp-page"
            data-elementor-id={17910}
            className="elementor elementor-17910"
          >
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-80ce6df elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="80ce6df"
              data-element_type="section"
            >
              {/* <div className="elementor-container elementor-column-gap-extended"> */}
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-a3659ee sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="a3659ee"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-34eee84 sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="34eee84"
                      data-element_type="widget"
                      data-widget_type="spacer.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-spacer">
                          <div className="elementor-spacer-inner" />
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-6136064 sc_style_default sc_fly_static elementor-widget elementor-widget-trx_sc_blogger trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id={6136064}
                      data-element_type="widget"
                      data-widget_type="trx_sc_blogger.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="sc_blogger sc_blogger_default sc_blogger_default_classic_simple sc_item_filters_tabs_none alignnone">
                          <div className="sc_blogger_columns_wrap sc_item_columns sc_item_posts_container trx_addons_columns_wrap columns_padding_bottom">
                            <div className="trx_addons_column-1_3">
                              <div
                                data-post-id={275}
                                data-item-number={1}
                                className="sc_blogger_item sc_item_container post_container sc_blogger_item_default sc_blogger_item_default_classic_simple sc_blogger_item_odd sc_blogger_item_align_none post_format_standard sc_blogger_item_with_image sc_blogger_item_no_excerpt sc_blogger_item_on_plate sc_blogger_item_image_position_top post-275 post type-post status-publish format-standard has-post-thumbnail hentry category-organic tag-agriculture tag-buy tag-crop tag-eco tag-equipment tag-farm tag-food"
                              >
                                <div className="sc_blogger_item_body">
                                  <div className="post_featured with_thumb hover_link sc_item_featured sc_blogger_item_featured">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={890}
                                      height={664}
                                      src="https://agricola.axiomthemes.com/wp-content/uploads/2022/07/typography-image1-copyright-890x664.jpg"
                                      className="attachment-agricola-thumb-square size-agricola-thumb-square wp-post-image"
                                      alt=""
                                    />{" "}
                                    <div className="mask" />
                                    <a
                                      href="/middle-east-food-security-the-strategic-role-of-grain-imports"
                                      aria-hidden="true"
                                      className="link"
                                    />
                                  </div>
                                  <div className="sc_blogger_item_content entry-content">
                                    <div className="post_meta sc_blogger_item_meta post_meta">
                              
                                      <span className="post_meta_item post_date">
                                        <a href="/middle-east-food-security-the-strategic-role-of-grain-imports">
                                          October 7, 2025
                                        </a>
                                      </span>
                                    </div>
                                    <h5
                                      className="sc_blogger_item_title entry-title"
                                      data-item-number={1}
                                    >
                                      <a
                                        href="/middle-east-food-security-the-strategic-role-of-grain-imports"
                                        rel="bookmark"
                                      >
                                       Middle East Food Security: The Strategic Role of Grain Imports
                                      </a>
                                    </h5>
                                  </div>
                                  {/* .entry-content */}
                                </div>
                                {/* .sc_blogger_item_body */}
                              </div>
                              {/* .sc_blogger_item */}
                            </div>
                            <div className="trx_addons_column-1_3">
                              <div
                                data-post-id={272}
                                data-item-number={2}
                                className="sc_blogger_item sc_item_container post_container sc_blogger_item_default sc_blogger_item_default_classic_simple sc_blogger_item_even sc_blogger_item_align_none post_format_standard sc_blogger_item_with_image sc_blogger_item_no_excerpt sc_blogger_item_on_plate sc_blogger_item_image_position_top post-272 post type-post status-publish format-standard has-post-thumbnail hentry category-organic tag-agriculture tag-buy tag-crop tag-eco tag-equipment tag-farm tag-food"
                              >
                                <div className="sc_blogger_item_body">
                                  <div className="post_featured with_thumb hover_link sc_item_featured sc_blogger_item_featured">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={890}
                                      height={664}
                                      src="https://agricola.axiomthemes.com/wp-content/uploads/2020/04/post-image1-copyright-890x664.jpg"
                                      className="attachment-agricola-thumb-square size-agricola-thumb-square wp-post-image"
                                      alt=""
                                    />{" "}
                                    <div className="mask" />
                                    <a
                                      href="/why-traceability-is-a-must-in-modern-agri-trade"
                                      aria-hidden="true"
                                      className="link"
                                    />
                                  </div>
                                  <div className="sc_blogger_item_content entry-content">
                                    <div className="post_meta sc_blogger_item_meta post_meta">
                                  
                                      <span className="post_meta_item post_date">
                                        <a href="/why-traceability-is-a-must-in-modern-agri-trade">
                                          October 7, 2025
                                        </a>
                                      </span>
                                    </div>
                                    <h5
                                      className="sc_blogger_item_title entry-title"
                                      data-item-number={2}
                                    >
                                      <a
                                        href="/why-traceability-is-a-must-in-modern-agri-trade"
                                        rel="bookmark"
                                      >
                                        Why Traceability Is a Must in Modern Agri-Trade
                                      </a>
                                    </h5>
                                  </div>
                                  {/* .entry-content */}
                                </div>
                                {/* .sc_blogger_item_body */}
                              </div>
                              {/* .sc_blogger_item */}
                            </div>
                            <div className="trx_addons_column-1_3">
                              <div
                                data-post-id={270}
                                data-item-number={3}
                                className="sc_blogger_item sc_item_container post_container sc_blogger_item_default sc_blogger_item_default_classic_simple sc_blogger_item_odd sc_blogger_item_align_none post_format_standard sc_blogger_item_with_image sc_blogger_item_no_excerpt sc_blogger_item_on_plate sc_blogger_item_image_position_top post-270 post type-post status-publish format-standard has-post-thumbnail hentry category-organic tag-agriculture tag-buy tag-crop tag-eco tag-equipment tag-farm tag-food"
                              >
                                <div className="sc_blogger_item_body">
                                  <div className="post_featured with_thumb hover_link sc_item_featured sc_blogger_item_featured">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={890}
                                      height={664}
                                      src="https://agricola.axiomthemes.com/wp-content/uploads/2020/04/post-image2-copyright-890x664.jpg"
                                      className="attachment-agricola-thumb-square size-agricola-thumb-square wp-post-image"
                                      alt=""
                                    />{" "}
                                    <div className="mask" />
                                    <a
                                      href="/grain-market-outlook-2025-trends-risks-and-opportunities"
                                      aria-hidden="true"
                                      className="link"
                                    />
                                  </div>
                                  <div className="sc_blogger_item_content entry-content">
                                    <div className="post_meta sc_blogger_item_meta post_meta">
                                 
                                      <span className="post_meta_item post_date">
                                        <a href="/grain-market-outlook-2025-trends-risks-and-opportunities">
                                          October 7, 2025
                                        </a>
                                      </span>
                                    </div>
                                    <h5
                                      className="sc_blogger_item_title entry-title"
                                      data-item-number={3}
                                    >
                                      <a
                                        href="/grain-market-outlook-2025-trends-risks-and-opportunities"
                                        rel="bookmark"
                                      >
                                        Grain Market Outlook 2025: Trends, Risks, and Opportunities
                                      </a>
                                    </h5>
                                  </div>
                                  {/* .entry-content */}
                                </div>
                                {/* .sc_blogger_item_body */}
                              </div>
                              {/* .sc_blogger_item */}
                            </div>
                            <div className="trx_addons_column-1_3">
                              <div
                                data-post-id={267}
                                data-item-number={4}
                                className="sc_blogger_item sc_item_container post_container sc_blogger_item_default sc_blogger_item_default_classic_simple sc_blogger_item_even sc_blogger_item_align_none post_format_standard sc_blogger_item_with_image sc_blogger_item_no_excerpt sc_blogger_item_on_plate sc_blogger_item_image_position_top post-267 post type-post status-publish format-standard has-post-thumbnail hentry category-organic tag-agriculture tag-buy tag-crop tag-eco tag-equipment tag-farm tag-food"
                              >
                                <div className="sc_blogger_item_body">
                                  <div className="post_featured with_thumb hover_link sc_item_featured sc_blogger_item_featured">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={890}
                                      height={664}
                                      src="https://agricola.axiomthemes.com/wp-content/uploads/2020/04/post-image5-copyright-890x664.jpg"
                                      className="attachment-agricola-thumb-square size-agricola-thumb-square wp-post-image"
                                      alt=""
                                    />{" "}
                                    <div className="mask" />
                                    <a
                                      href="/sustainable-sourcing-in-the-commodity-trade-sector"
                                      aria-hidden="true"
                                      className="link"
                                    />
                                  </div>
                                  <div className="sc_blogger_item_content entry-content">
                                    <div className="post_meta sc_blogger_item_meta post_meta">
                                  
                                      <span className="post_meta_item post_date">
                                        <a href="/sustainable-sourcing-in-the-commodity-trade-sector">
                                          October 7, 2025
                                        </a>
                                      </span>
                                    </div>
                                    <h5
                                      className="sc_blogger_item_title entry-title"
                                      data-item-number={4}
                                    >
                                      <a
                                        href="/sustainable-sourcing-in-the-commodity-trade-sector"
                                        rel="bookmark"
                                      >
                                        Sustainable Sourcing in the Commodity Trade Sector
                                      </a>
                                    </h5>
                                  </div>
                                  {/* .entry-content */}
                                </div>
                                {/* .sc_blogger_item_body */}
                              </div>
                              {/* .sc_blogger_item */}
                            </div>
      
                          
                       
                          
                          
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-9237bab sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="9237bab"
                      data-element_type="widget"
                      data-widget_type="spacer.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-spacer">
                          <div className="elementor-spacer-inner" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              {/* </div> */}
            </section>
          </div>
        </div>
        {/* .entry-content */}
      </article>
    </div>
  </div>
// </div>
// </div>
  )
}
